import React, { ReactNode } from "react";

const CHUNK_RELOAD_KEY = "chunk_reload_attempted";

interface ChunkErrorBoundaryProperties {
  children: ReactNode;
}

class ChunkErrorBoundary extends React.Component<ChunkErrorBoundaryProperties> {
  static getDerivedStateFromError(error: unknown) {
    if (ChunkErrorBoundary.isChunkError(error)) {
      return {};
    }
    return null;
  }

  componentDidCatch(error: unknown) {
    console.error("Caught error in ChunkErrorBoundary:", error);

    if (!ChunkErrorBoundary.isChunkError(error)) {
      return;
    }

    const alreadyTried = sessionStorage.getItem(CHUNK_RELOAD_KEY);

    if (alreadyTried) {
      sessionStorage.removeItem(CHUNK_RELOAD_KEY);
      console.warn("ChunkLoadError occurred again after reload. Skipping reload to avoid loop.");
    } else {
      sessionStorage.setItem(CHUNK_RELOAD_KEY, "true");
      window.location.reload();
    }
  }

  static isChunkError(error: unknown): error is { name?: string; message?: string } {
    if (typeof error === "object" && error !== null) {
      const error_ = error as { name?: string; message?: string };
      return (
        error_.name === "ChunkLoadError" ||
        (typeof error_.message === "string" && error_.message.includes("Loading chunk"))
      );
    }
    return false;
  }

  render() {
    return this.props.children;
  }
}

export default ChunkErrorBoundary;
